export interface IJournal {
  uid?: string
  id: string
  title?: string
  date: Date
  content?: string
  sentiment: string
}

export const emptyJournal = {
  uid: '',
  id: '',
  title: '',
  date: new Date(),
  content: '',
  sentiment: 'NEU'
}
